import script from "./ChatInputv3.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInputv3.vue?vue&type=script&setup=true&lang=js"

import "./ChatInputv3.vue?vue&type=style&index=0&id=c918c864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c918c864"]])

export default __exports__